<template>
    <div class="container">
        <LoadingBlock v-if="!hasBoilerManufacturer && isLoading"/>
        <RouterView v-if="hasBoilerManufacturer"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import LoadingBlock from "../../Common/UI/LoadingBlock.vue"

export default {

    components: {
        LoadingBlock,
    },

    computed: {
        ...mapGetters({
            isLoading: 'appliance/manufacturers/isLoading',
            hasBoilerManufacturer: 'appliance/manufacturers/hasManufacturer',
            boilerManufacturer: 'appliance/manufacturers/getManufacturer',
        }),
    },

    created() {
        this.$store.dispatch("appliance/manufacturers/clear")
        this.loadBoilerManufacturer(this.$route.params.id)
    },

    methods: {

        loadBoilerManufacturer(id) {
            this.$store.dispatch("appliance/manufacturers/getManufacturer", id)
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
        },

    },

}
</script>
